// Import Swiper core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

const product_features = document.querySelectorAll('[id^="product_features_"]');

product_features.forEach(el => {
  let product_feature_slider = new Swiper ('#' + el.id + ' .swiper', {
    navigation: {
      nextEl: '#' + el.id + ' .swiper-button-next',
      prevEl: '#' + el.id + ' .swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
      },
      400: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.5,
      },
      1000: {
        slidesPerView: 3.75,
      },
      1480: {
        slidesPerView: 4,
      },
    },
  });
});
